import React, { Component, PropTypes } from 'react';
import connect from '../../utils/connect';
import ContextualJobs from '../../components/contextual/contextualJobs';
import ContextualProfiles from '../../components/contextual/contextualProfiles';
import ContextualCases from '../../components/contextual/contextualCases';
import ContextualDefault from '../../components/contextual/contextualDefault';
import ContextualImage from '../../components/contextual/contextualImage';
import css from './contextual.scss';

import relLinks from '../../utils/relLinks';

class ContextualMenu extends Component {
	static propTypes = {};

	constructor(props) {
		super(props);

		this.prev = '';
		this.next = '';
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props !== nextProps ||
			this.state !== nextState
		);
	}

	render() {
		let seen = false;
		if (localStorage.getItem('context') == 'seen') {
			seen = true;
		}

		

		let url = window.location.href;
		let remove = window.location.href.split('/')[window.location.href.split('/').length -1];

		let prev = '';
		let next = '';

		if (this.props.next) {
			next = url.replace(remove, this.props.next);
		}

		if (this.props.prev) {
			prev = url.replace(remove, this.props.prev);
		}

		if (this.props.nextProfile) {
			next = url.replace(remove, this.props.nextProfile);
		}

		if (this.props.prevProfile) {
			prev = url.replace(remove, this.props.prevProfile);
		}

		if (!this.props.enableJobs && (this.prev !== prev || this.next !== next)) {
			relLinks(prev, next);
			this.prev = prev;
			this.next = next;
		}

		return (
			this.props.enableJobs && (
				<ContextualJobs seen={seen} jobId={this.props.jobId} enableJobs={true} />
			) || this.props.enableProfiles && (
				<ContextualProfiles seen={seen} enableProfiles={true} nextProfile={this.props.nextProfile} prevProfile={this.props.prevProfile} />
			) || this.props.enableCases && (
				<ContextualCases seen={seen} enableCases={true} next={this.props.next} prev={this.props.prev} />
			) || this.props.editorial && this.props.type == 'CONTEXT_DEFAULT' && (
				<ContextualDefault seen={seen} dateFilter={this.props.dateFilter} typeSlug={this.props.typeSlug} next={this.props.next} prev={this.props.prev} typeId={this.props.typeId} intro={this.props.intro} interviewId={this.props.thisId} enableNews={true} name={this.props.name} />
			) || this.props.editorial && this.props.type == 'CONTEXT_IMAGE' && (
				<ContextualImage seen={seen} dateFilter={this.props.dateFilter} typeSlug={this.props.typeSlug} next={this.props.next} prev={this.props.prev} typeId={this.props.typeId} intro={this.props.intro} interviewId={this.props.thisId} enableNews={true} name={this.props.name} />
			) ||
				null
		);
	}
}

export default connect(ContextualMenu);



/** WEBPACK FOOTER **
 ** ./frontend/components/contextual/contextual.js
 **/